import "../../external/preact/compat/dist/compat.module.js";
import { jsx as t } from "../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
const e = (i) => /* @__PURE__ */ t("svg", { width: 11, height: 11, viewBox: "0 0 11 11", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i, children: /* @__PURE__ */ t("path", { d: "M0.939453 9L8.18945 1.75H3.25011V0.25H10.7501V7.75H9.25011V2.81066L2.00011 10.0607L0.939453 9Z", fill: "#00112C" }) });
export {
  e as default
};
